import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { environment } from '../../../environments/environment'; // Corrected import path for environment
import { NewsletterSubscribeComponent } from '../../components/newsletter-subscribe/newsletter-subscribe.component';
import { SEOService } from '../../services/seo.service';
import { StructuredDataService } from '../../services/structured-data.service';

@Component({
  selector: 'app-subscribe',
  standalone: true,
  imports: [CommonModule, NewsletterSubscribeComponent],
  templateUrl: './subscribe.component.html',
  styleUrl: './subscribe.component.scss',
})
export class SubscribeComponent implements OnInit {
  private seoService = inject(SEOService);
  private structuredDataService = inject(StructuredDataService);

  ngOnInit() {
    const canonicalUrl = `${environment.canonicalOrigin}/subscribe`;
    this.setSeoMetadata(canonicalUrl);
    this.setStructuredData();
  }

  private setSeoMetadata(canonicalUrl: string) {
    this.seoService.updateTags({
      title: 'Subscribe to Summerry Newsletter | Summerry',
      description:
        'Subscribe to receive the latest AI news summaries directly to your inbox. Stay informed with curated AI insights and technology updates.',
      keywords:
        'AI newsletter, technology updates, AI news subscription, artificial intelligence updates, tech newsletter',
      url: canonicalUrl,
      type: 'website',
      image: `${environment.canonicalOrigin}/assets/og/black-og-image-1x.png`,
    });
  }

  private setStructuredData() {
    const origin = environment.canonicalOrigin;
    const subscribeAction = {
      '@type': 'SubscribeAction',
      name: 'Subscribe to Newsletter',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${environment.apiUrl}/newsletter/subscribe`,
        actionPlatform: ['http://schema.org/DesktopWebPlatform', 'http://schema.org/MobileWebPlatform'],
      },
    };

    this.structuredDataService.addWebPage({
      name: 'Subscribe to Summerry Newsletter',
      description:
        'Subscribe to receive the latest AI news summaries directly to your inbox. Stay informed with curated AI insights and technology updates.',
      breadcrumbItems: [{ name: 'Home', item: origin }, { name: 'Subscribe' }],
      potentialAction: subscribeAction, // Pass the action here
    });
  }
}
